/*
  Import all Angular components via ES6 imports and register them
*/
import LoginController from '../controllers/LoginController';
import PortalController from '../controllers/PortalController';
import FormatHTML from '../services/FormatHTML';
//import CompileDirectory from '../services/CompileDirective';
//import CamelCase from '../services/CamelCase';
//import TrustAsHtml from '../services/TrustAsHtml';

angular.module('dmsGenerali', ['ngRoute', 'ngAnimate', 'ui.knob', 'ngValidate', 'angular-ladda', 'ngStorage'])
	.controller('LoginController', LoginController)
	.controller('PortalController', PortalController)
	.directive('compile', ($compile, $timeout)=> {
		return {
			restrict:'A',
			link: (scope, elem, attrs)=> {
				$compile(elem.contents())(scope);
			}
		};
	}).directive('aliasKeyPress', function () {
	    return function (scope, element, attrs) {
	        element.bind("keydown keypress keyup", function (event) {
				var value = attrs.$$element[0].value;

                scope.$apply(function (){
                    //scope.$eval(attrs.aliasKeyPress);

					//console.log(event.which);
					//console.log(event.key);
                });

				scope[attrs.aliasKeyPress](value, event.key, attrs.$$element[0]).then((v)=>{
					if (v.success === false) {
						attrs.$$element[0].value = v.value.substring(0, (v.value.length - 1));
					} else {
						if (v.value !== undefined) {
							attrs.$$element[0].value = v.value;
						}
					}

					if (v === false) {
						event.preventDefault();
					}
				});
	        });
	    };
	}).directive('bindHtmlCompile', ['$compile', function ($compile) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(function () {
                    return scope.$eval(attrs.bindHtmlCompile);
                }, function (value) {
                    // In case value is a TrustedValueHolderType, sometimes it
                    // needs to be explicitly called into a string in order to
                    // get the HTML string.
                    element.html(value && value.toString());
                    // If scope is provided use it, otherwise use parent scope
                    var compileScope = scope;
                    if (attrs.bindHtmlScope) {
                        compileScope = scope.$eval(attrs.bindHtmlScope);
                    }
                    $compile(element.contents())(compileScope);
                });
            }
        };
    }]).directive('inputHealthChecker', function($compile) {
    	return function (scope, element, attr) {
    		element.bind("keypress keyup blur", function(event) {
                var hidden_fields = $('div.health-checker input[type=hidden]'),
                    passwd_val = $(this).val();

                //Policies array would be initiated from outside of this controller within the DOM
                policies = [];

                hidden_fields.each(function() {
                    let policy = JSON.parse($(this).val());

                    policy.status = 0;
                    policies.push(policy);
                });

                policies.forEach((value)=> {
                    let list_name = $(`ul li.${value.name}`);

                    value.status = 0;

                    if (value.type === 'length') {
                        if (passwd_val.length >= value.value) {
                            value.status = 1;
                        }
                    }

                    if (value.type === 'regex') {
                        let string = value.value,
                            match = passwd_val.match(string);

                        if (match) {
                            value.status = 1;
                        }
                    }

                    if (value.status === 1) {
                        list_name.addClass('accepted');
                        list_name.find('span').html('<svg><use xlink:href="#accept" /></svg>');
                    } else {
                        list_name.removeClass('accepted');
                        list_name.find('span').html('<svg><use xlink:href="#cancel" /></svg>');
                    }
                });
			});
		};
    }).filter('camelCase',function(){
		return function(input) {
			if (input === undefined) {
				return;
			}

			var str_lower = input.toLowerCase(),
				str_split = str_lower.split(" ");

			for (var i in str_split) {
				var str = str_split[i];

				str_split[i] = str.substring(0, 1).toUpperCase() + str.substring(1);
			}

			return str_split.join(" ");
		};
	}).filter('trustAsHtml', ['$sce', function($sce){
		return function(input) {
			return $sce.trustAsHtml(input);
		};
	}]).filter('formatHtml', ['$sce', ($sce)=>{
		return function(input) {
			var content = new FormatHTML();
			
			return content.showString(input);
		};
	}]).config(['$routeProvider', '$locationProvider' , ($routeProvider, $locationProvider)=> {
		$locationProvider
			.html5Mode({
			enabled: true,
			requireBase: true
		});
	}]);
